/* eslint-disable react-hooks/exhaustive-deps */
import {
  AddIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  CheckIcon,
  DeleteIcon,
  Search2Icon,
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useGlobalFilter, usePagination, useTable } from "react-table";

export default function EditCodeForm({
  apiData,
  onSubmit,
  formRef,
  setDescription,
  desctiption,
}) {
  const [filterInput, setFilterInput] = useState("");
  const { register, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      options: apiData?.CONFIG || [],
    },
  });

  const [editIndex, setEditIndex] = useState(null);
  const data = watch("options");
  const hoverBg = useColorModeValue("gray.100", "gray.700");

  const columns = useMemo(
    () => [
      {
        Header: "Text",
        accessor: "TEXT",
        Cell: ({ row, value }) =>
          editIndex === row.index ? (
            <Input
              {...register(`options.${row.index}.TEXT`)}
              placeholder="Text"
              size="sm"
            />
          ) : (
            <Text>{value}</Text>
          ),
      },
      {
        Header: "Code",
        accessor: "CODE",
        Cell: ({ row, value }) =>
          editIndex === row.index ? (
            <Input
              {...register(`options.${row.index}.CODE`)}
              placeholder="Code"
              size="sm"
            />
          ) : (
            <Text>{value}</Text>
          ),
      },

      {
        Header: "Subgroup",
        accessor: "SUBGROUP",
        Cell: ({ row, value }) =>
          editIndex === row.index ? (
            <Input
              {...register(`options.${row.index}.SUBGROUP`)}
              placeholder="Subgroup"
              size="sm"
            />
          ) : (
            <Text color={value ? "black" : "gray.400"}>{value || "—"}</Text>
          ),
      },
      {
        Header: "Actions",
        Cell: ({ row }) =>
          editIndex === row.index ? (
            <Flex justify="start" gap={4}>
              <CheckIcon
                onClick={(e) => {
                  e.stopPropagation();
                  setEditIndex(null);
                }}
                cursor="pointer"
                _hover={{ color: "green" }}
                fontSize={15}
              />
            </Flex>
          ) : (
            <Flex justify="start" gap={5}>
              <DeleteIcon
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteRow(row.index);
                }}
                fontSize="15px"
                cursor="pointer"
                color="red"
              />
            </Flex>
          ),
      },
    ],
    [editIndex, register, data]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setGlobalFilter,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
    },

    useGlobalFilter,
    usePagination
  );

  const handleAddRow = () => {
    const newRow = {
      TEXT: "",
      CODE: "",
      SUBGROUP: "",
    };
    const updated = [newRow, ...data];
    setValue("options", updated);
    setEditIndex(0);
  };

  const handleDeleteRow = (index) => {
    const updated = [...data];
    updated.splice(index, 1);
    setValue("options", updated);
    setEditIndex(null);
  };

  useEffect(() => {
    if (formRef) {
      formRef.current = {
        submit: handleSubmit((values) => onSubmit(values.options)),
      };
    }
  }, [formRef, handleSubmit, onSubmit]);
  const handleSearchChange = (e) => {
    const value = e.target.value || undefined;
    setGlobalFilter(value);
    setFilterInput(value);
  };

  return (
    <Box>
      <form>
        <Flex mb={1} justify="space-between" align="center">
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Search2Icon color="gray.300" />
            </InputLeftElement>
            <Input
              placeholder="Search codes..."
              value={filterInput}
              onChange={handleSearchChange}
              width="300px"
              borderRadius="md"
              _focus={{ ring: "none", outline: "none" }}
            />
          </InputGroup>
          <Button
            mr={6}
            leftIcon={<AddIcon />}
            colorScheme="teal"
            onClick={handleAddRow}
            size="sm"
          >
            Add New
          </Button>
        </Flex>

        <TableContainer
          maxH="55vh"
          overflowY="auto"
          border="2px solid gray"
          borderRadius="lg"
        >
          <Table {...getTableProps()} variant="simple" size="sm">
            <Thead position="sticky" top={0} zIndex={1} boxShadow="sm">
              {headerGroups.map((headerGroup) => (
                <Tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <Th {...column.getHeaderProps()}>
                      {column.render("Header")}
                    </Th>
                  ))}
                </Tr>
              ))}
            </Thead>
            <Tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <Tr
                    {...row.getRowProps()}
                    _hover={{ bg: hoverBg }}
                    cursor="pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      setEditIndex(row.index);
                    }}
                  >
                    {row.cells.map((cell) => (
                      <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                    ))}
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>

        <Flex justify="space-between" align="center" mt={1}>
          <Text fontSize="sm" color="gray.600">
            Page {pageIndex + 1} of {pageOptions.length}
          </Text>
          <Box display="flex" gap={5}>
            <ArrowLeftIcon
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              cursor="pointer"
            />
            <ArrowRightIcon
              onClick={() => nextPage()}
              disabled={!canNextPage}
              cursor="pointer"
            />
          </Box>
        </Flex>
      </form>
      <Box mt={1}>
        <Text fontWeight={600} fontSize="md">
          {" "}
          Description
        </Text>
        <Textarea
          onChange={(e) => setDescription(e.target.value)}
          row={3}
          border="1px solid gray"
          _focus={{ ring: "none", outline: "none" }}
          value={desctiption}
        />
      </Box>
    </Box>
  );
}
